<ion-menu side="end" content-id="main-content" (ionDidOpen)="openMenu()">
  <ion-header>
    <ion-toolbar ion-padding>
      <div slot="start" class="home-close" (click)="homeClick()">
        <span class="home-outline"></span>
        <ion-label class="home-label">{{ 'HOME' | translate }}</ion-label>
      </div>

      <div slot="end">
        <ion-menu-toggle class="home-close">
          <ion-icon name="close" class="close-icon"></ion-icon>
          <ion-label class="close-label">{{ 'CLOSE' | translate }}</ion-label>
        </ion-menu-toggle>
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-accordion-group #accordId [multiple]=true [value]="productAccordionValue" 
      *ngFor="let product of productList; index as i">
      <ion-accordion [value]="product.productName">
        <ion-item lines="none" slot="header" (click)="selectedProduct(
          {name: product.productName,
            selectedIndex: i })">
          <ion-label>{{ product.productName }}</ion-label>
        </ion-item>
        <div slot="content" class="content" no-lines>
          <ion-accordion-group #accordSubId [multiple]=true [value]="accordionValue"
            *ngFor="let section of product.sections; index as idx">
            
            <ion-item lines="none">
              <ion-accordion [value]="product.productName+idx">
                <ion-label class="section" (click)="selectedProductSection({sectionName:section.title,sectionIndex: idx})" [ngClass]="{'section-blue': section.isReactivePage}" slot="header">{{ section.title | titlecase }}</ion-label>
                @if(section.sections && section.sections.length > 0){
                <div slot="content" class="sub-section">
                  <div class="divider ion-margin-top ion-margin-bottom"></div>
                  <div class="ion-padding" no-lines>
                    <ion-label (click)="scrollToSection(subSection.id, j)" class="ion-padding-bottom" color="primary"
                      *ngFor="let subSection of section.sections; let j = index" [innerHTML]="subSection.title"></ion-label>
                  </div>

                </div>
              }
              </ion-accordion>
            </ion-item>
          </ion-accordion-group>
          <app-section-buttons from="side-menu" (selectedTypeChange)="showReferences(true)"></app-section-buttons>
        </div>
        
      </ion-accordion>
    </ion-accordion-group>
    <app-reference [reference]="references" showAllReferences="true" (showReferencesModal)="showReferences($event)"></app-reference>
    @if (isExternal) {
      <ion-item 
        lines="none" 
        class="eula-item" 
        (click)="openTermsAndPrivacy('terms', 'TERMS_AND_CONDITIONS')">
        <ion-label class="eula-label">
          {{ 'TERMS_AND_CONDITIONS' | translate }}
        </ion-label>
      </ion-item>
      <ion-item 
        lines="none" 
        class="eula-item" 
        (click)="openTermsAndPrivacy('privacy', 'PRIVACY_POLICY' )">
        <ion-label class="eula-label">
          {{ 'PRIVACY_POLICY' | translate }}
        </ion-label>
      </ion-item>
    }
    <div class="blank"></div>

    <ion-accordion-group class="select-theme">
      <ion-accordion value="'theme'">
        <ion-item lines="none" slot="header">
          <ion-label>{{ 'SELECT_THEME' | translate }}</ion-label>
        </ion-item>
        <div slot="content">
          <app-select-theme></app-select-theme>
        </div>
      </ion-accordion>
    </ion-accordion-group>


  </ion-content>
</ion-menu>